import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "ion-text-center" }
const _hoisted_2 = ["src"]
const _hoisted_3 = ["src"]
const _hoisted_4 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_buttons = _resolveComponent("ion-buttons")!
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_ion_title = _resolveComponent("ion-title")!
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")!
  const _component_ion_header = _resolveComponent("ion-header")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_footer = _resolveComponent("ion-footer")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_ion_header, null, {
      default: _withCtx(() => [
        _createVNode(_component_ion_toolbar, null, {
          default: _withCtx(() => [
            _createVNode(_component_ion_buttons, { slot: "start" }, {
              default: _withCtx(() => [
                _createVNode(_component_ion_button, {
                  slot: "icon-only",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.closeModal()))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_icon, { icon: _ctx.arrowBack }, null, 8, ["icon"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_ion_title, { style: {"padding-right":"0"} }, {
              default: _withCtx(() => [
                _createVNode(_component_ion_label, { class: "ion-text-wrap" }, {
                  default: _withCtx(() => [
                    _createElementVNode("p", null, _toDisplayString(_ctx.getTitle()), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_ion_content, { fullscreen: true }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("p", null, [
            _createElementVNode("img", {
              width: "200",
              src: _ctx.getQRCodeUrl(`https://${_ctx.getUrl(_ctx.user, _ctx.event)}`)
            }, null, 8, _hoisted_2),
            _cache[2] || (_cache[2] = _createElementVNode("br", null, null, -1)),
            _createTextVNode(" " + _toDisplayString(_ctx.getUrl(_ctx.user, _ctx.event)), 1)
          ])
        ]),
        _createElementVNode("div", null, [
          _createElementVNode("img", {
            style: {"width":"100%"},
            src: _ctx.getProxyImgLink(_ctx.event?.posterLink || _ctx.service?.posterLink)
          }, null, 8, _hoisted_3),
          (_ctx.event?.videoLink || _ctx.service?.embeddedYTLink)
            ? (_openBlock(), _createElementBlock("iframe", {
                key: 0,
                style: {"width":"100%","height":"380px"},
                src: _ctx.event?.videoLink || _ctx.service?.embeddedYTLink,
                frameborder: "0",
                allowfullscreen: ""
              }, null, 8, _hoisted_4))
            : _createCommentVNode("", true)
        ])
      ]),
      _: 1
    }),
    _createVNode(_component_ion_footer, null, {
      default: _withCtx(() => [
        _createVNode(_component_ion_toolbar, null, {
          default: _withCtx(() => [
            _createVNode(_component_ion_button, {
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.sendLinkToMyWhatsApp(`https://${_ctx.getUrl(_ctx.user, _ctx.event)}`, _ctx.user.phone, _ctx.user.waGroupId, _ctx.event?.posterLink || _ctx.service?.posterLink, _ctx.service?.videoLink))),
              expand: "full",
              color: "success",
              style: {"text-transform":"none","height":"48px"}
            }, {
              default: _withCtx(() => _cache[3] || (_cache[3] = [
                _createTextVNode(" Send to my WhatsApp group"),
                _createElementVNode("br", null, null, -1),
                _createTextVNode("for me to forward to them ")
              ])),
              _: 1,
              __: [3]
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ], 64))
}